import env from '@app/environment'

export const EMBED_ALLOWED_ORIGINS = [
  'https://mondcasino1.com',
  'https://mondcasino2.com',
  'https://mondcasino3.com',
  'https://mond1casino.com',
  'https://prelive.mondcasino.com',
  'http://localhost:9000',
]

export const EMBED_MESSAGE_TYPE = 'TIPSTERIZER_INIT'

export const EMBED_STORAGE_KEYS = {
  token: 'embed_partner_token',
  origin: 'embed_partner_origin',
}

interface EmbedInitPayload {
  type: typeof EMBED_MESSAGE_TYPE
  mode: 'guest' | 'authenticated'
  token?: string
}

interface EmbedBridgeHandlers {
  onGuest: (origin: string) => void
  onAuthenticated: (token: string, origin: string) => void
}

const isAllowedOrigin = (origin: string): boolean => {
  if (EMBED_ALLOWED_ORIGINS.includes(origin)) return true
  if (env.APP_ENVIRONMENT !== 'prod' && origin === 'http://localhost:9000') return true
  return false
}

const isEmbedInitPayload = (data: unknown): data is EmbedInitPayload => {
  if (!data || typeof data !== 'object') return false
  const candidate = data as Record<string, unknown>
  return candidate.type === EMBED_MESSAGE_TYPE
}

export const notifyParentReady = (): void => {
  if (window.parent === window) return
  for (const origin of EMBED_ALLOWED_ORIGINS) {
    window.parent.postMessage({ type: 'TIPSTERIZER_READY' }, origin)
  }
}

export const registerEmbedBridge = (handlers: EmbedBridgeHandlers): (() => void) => {
  const listener = (event: MessageEvent): void => {
    if (!isAllowedOrigin(event.origin)) return
    if (!isEmbedInitPayload(event.data)) return

    const payload = event.data

    if (payload.mode === 'authenticated') {
      if (!payload.token) return
      localStorage.setItem(EMBED_STORAGE_KEYS.token, payload.token)
      localStorage.setItem(EMBED_STORAGE_KEYS.origin, event.origin)
      handlers.onAuthenticated(payload.token, event.origin)
      return
    }

    localStorage.setItem(EMBED_STORAGE_KEYS.origin, event.origin)
    handlers.onGuest(event.origin)
  }

  window.addEventListener('message', listener)
  notifyParentReady()

  return () => window.removeEventListener('message', listener)
}
